import {useMutation} from "@tanstack/react-query";
import {approveCustomerOfferMutationOptions} from "./approve-customer-offer.mutation-options";

export function useApproveCustomerOffer() {
  return useMutation(approveCustomerOfferMutationOptions());
}
